const _roundStatus = {
  EDITING_BASIS: 'Editing Basis',
  EDITING_NLP_OUTLINE: 'Editing NLP Outline',
  EDITING_OUTLINED_ANALYZED: 'Editing Outlined Analyzed',
  ANALYZING_BASIS: 'Analyzing Basis',
  DRAFTING: 'Drafting',
  FINALIZING: 'Finalizing',
  PUBLISHED: 'Published',
  HOST: 'Host Instructions',
};

const _roundStatusDisplayName = roundStatus => {
  switch (roundStatus) {
    case _roundStatus.EDITING_BASIS:
    case _roundStatus.ANALYZING_BASIS:
    case _roundStatus.EDITING_OUTLINED_ANALYZED:
    case _roundStatus.EDITING_NLP_OUTLINE:
      return 'Framing';
    case _roundStatus.DRAFTING:
      return 'Drafting';
    case _roundStatus.FINALIZING:
      return 'Finalizing';
    case _roundStatus.PUBLISHED:
      return 'Published';
  }
};

export default Object.freeze(_roundStatus);
export const roundStatusDisplayName = _roundStatusDisplayName;
